module.exports = __webpack_public_path__ + "static/banner-update-data-bo-a3c79470d384f962701b9ea07b834e04.png";